export default __webpack_public_path__ + "static/optional_steps_water_heating-467665c04a68bfaf3d037f210eec8b5b.png";